import { ApplicationInsights } from '@microsoft/1ds-analytics-web-js';
import { NEZHA_OPERATION } from 'src/telemetry/constants/CommonEventsContants';
import { NezhaTelemetry } from 'src/telemetry/helper/CommonTelemetryHelper';
import { getPathname, parseScenarioFromUri } from 'src/telemetry/util';

export const trackClickEvent = (
  analytics: ApplicationInsights,
  nestedText: string,
  nodeType: string,
) => {
  try {
    if (analytics) {
      console.info('Track Click Event:', nestedText);
      NezhaTelemetry.trackEngagementEvent(analytics, {
        scenario: parseScenarioFromUri(getPathname()),
        operation: NEZHA_OPERATION.CLICK,
        customProperties: {
          content: nestedText,
          nodeType,
        },
      });
    }
  } catch (error) {
    console.warn('Error tracking click event:', error);
  }
};
